import React, { useState } from "react";
import "./WeeksofService.css";
import { useNavigate } from "react-router-dom";

const WeeksofService = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    return (
        <section className="categories">
            <div className="container-fluid">
                <div className="row mt-1">

                    {/* <div className="col-lg-4 col-md-12 col-sm-12 text-center">
            <div className="cat-inner">
              <h5>Mental health and well-being</h5>
              <p>October 4–12, 2025</p>
            </div>
          </div> */}
                    <div className="col-lg-4 text-center">
                        <div className="cat-inner" onClick={() => navigate("/mhw")}>
                            <h5>Mental health and well-being</h5>
                            <p>October 4–12, 2025</p>
                        </div>
                    </div>

                    {/*  <div className="col-lg-4 col-md-12 col-sm-12 text-center">
                        <div className="cat-inner">
                            <h5>Hunger</h5>
                            <p>January 3–11, 2026</p>
                        </div>
                        </div> */}

                    <div className="col-lg-4 text-center">
                        <div className="cat-inner" onClick={() => navigate("/hunger")}>
                            <h5>Hunger</h5>
                            <p>January 3–11, 2026</p>
                        </div>
                    </div>

                    {/* <div className="col-lg-4 col-md-12 col-sm-12 text-center">
                            <div className="cat-inner">
                                <h5>Environment</h5>
                                <p>April 18–26, 2026</p>
                            </div>
                        </div> */}

                    <div
                        className="col-lg-4 col-md-12 col-sm-12 text-center"
                        onClick={() => setShowModal(true)}
                        style={{ cursor: "pointer" }}
                    >
                        <div className="cat-inner">
                            <h5>Environment</h5>
                            <p>April 18–26, 2026</p>
                        </div>
                    </div>

                    {showModal && (
                        <div className="modal-overlay">
                            <div className="modal-box">
                                <h3>Coming Soon 🚧</h3>
                                <p>This section will be available soon.</p>
                                <button onClick={() => setShowModal(false)}>OK</button>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </section>
    );
};

export default WeeksofService;